var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _ellipse, _ellipse2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteAccountOtp = function SvgDeleteAccountOtp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 102,
    viewBox: "0 0 150 102",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2444_3193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 102
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 0.5H0.5V101.5H149.5V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2444_3193)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2444_3193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 94,
    width: 143,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.658 94.985H3.15527V101.675H145.658V94.985Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2444_3193)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2444_3193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 95,
    width: 47,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3063 95.325H3.15527V101.675H49.3063V95.325Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2444_3193)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.35742,
    y: 94.516,
    width: 47.338,
    height: 7.426,
    fill: "url(#pattern0)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2444_3193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 94,
    width: 45,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1291 94.985H5.57812V95.722H49.1291V94.985Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2444_3193)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.1416,
    y: 94.515,
    width: 44.554,
    height: 1.856,
    fill: "url(#pattern1)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2444_3193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 95,
    width: 41,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.658 95.325H105.735V101.675H145.658V95.325Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2444_3193)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.388,
    y: 94.516,
    width: 40.841,
    height: 7.426,
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2444_3193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 94,
    width: 39,
    height: 2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.563 94.985H105.89V95.722H143.563V94.985Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2444_3193)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.388,
    y: 94.515,
    width: 38.984,
    height: 1.856,
    fill: "url(#pattern3)"
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 119.899,
    cy: 38.0027,
    rx: 16,
    ry: 15,
    transform: "rotate(5.65125 119.899 38.0027)",
    fill: "url(#paint0_linear_2444_3193)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 30.9997,
    cy: 39.5,
    rx: 12.5,
    ry: 12,
    transform: "rotate(-13.6011 30.9997 39.5)",
    fill: "url(#paint1_linear_2444_3193)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3462 101.667H48.0752L51.0202 66.389H91.3462V101.667Z",
    fill: "#122048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2841 101.941H73.2401C73.1687 101.929 73.1049 101.89 73.0626 101.831C73.0203 101.772 73.0028 101.699 73.0141 101.628L78.3911 67.931C78.3959 67.8949 78.4079 67.8601 78.4264 67.8287C78.4448 67.7973 78.4694 67.7698 78.4986 67.7481C78.5279 67.7263 78.5612 67.7106 78.5966 67.7019C78.6319 67.6932 78.6687 67.6917 78.7047 67.6975C78.7407 67.7032 78.7752 67.7161 78.8061 67.7354C78.837 67.7546 78.8638 67.7799 78.8848 67.8097C78.9058 67.8395 78.9206 67.8732 78.9284 67.9088C78.9362 67.9444 78.9368 67.9812 78.9301 68.017L73.5551 101.711C73.5447 101.775 73.5119 101.833 73.4626 101.875C73.4133 101.917 73.3508 101.94 73.2861 101.94",
    fill: "#5D7B6B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5602 17.985C53.0602 16.742 54.1792 12.432 55.7312 10.928C57.6862 9.028 60.0632 9.236 62.3252 8.128C67.4742 5.612 69.9682 -0.511999 76.6052 1.609C77.5059 1.85411 78.3062 2.3773 78.8922 3.10399C79.4781 3.83068 79.8196 4.72379 79.8682 5.656C80.0452 7.119 79.4472 8.662 80.6002 9.785C81.5442 10.703 83.2522 10.752 84.2212 11.779C85.3551 13.1574 86.0386 14.8507 86.1792 16.63C86.3062 18.566 85.3982 20.098 84.8152 21.894C83.6592 25.448 87.1482 27.821 88.0342 31.168C89.9242 38.322 84.3672 46.22 77.5032 47.839C72.3722 49.05 66.9232 48.054 61.7582 49.172C57.3282 50.132 53.2702 51.054 48.7632 49.827C44.7472 48.735 40.0812 46.288 39.7292 41.617C39.4682 38.248 41.4512 36.78 44.0362 35.161C47.1672 33.199 44.2232 32.661 42.8922 30.561C40.6862 27.08 42.9872 23.441 46.3772 22.242C48.8532 21.367 51.9772 21.162 54.2122 19.691C54.5682 19.456 55.5782 18.31 55.5602 17.991",
    fill: "#29314A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.62 42.103C101.845 35.347 86.0508 28.716 86.0508 28.716C82.7761 26.237 78.9111 24.6555 74.8378 24.128L66.5528 23.918C66.5528 23.918 57.8308 26.869 53.2988 33.679C48.5838 40.766 40.5248 53.579 43.7898 62.373C47.6898 72.881 58.4898 68.221 58.4898 68.221H92.9098L92.3648 52.173C101.938 53.094 107.314 48.651 104.624 42.103",
    fill: "#172C64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.857 42.498C84.8013 42.4978 84.747 42.4806 84.7014 42.4487C84.6558 42.4168 84.6211 42.3717 84.6018 42.3195C84.5826 42.2672 84.5797 42.2104 84.5937 42.1565C84.6077 42.1026 84.6378 42.0543 84.68 42.018C86.4232 40.6658 88.4399 39.7092 90.5901 39.2148C92.7402 38.7204 94.9722 38.7 97.131 39.155C97.1659 39.1631 97.1989 39.1781 97.228 39.199C97.2572 39.2199 97.282 39.2463 97.3009 39.2768C97.3198 39.3072 97.3326 39.3411 97.3385 39.3765C97.3443 39.4119 97.3431 39.4481 97.335 39.483C97.3268 39.5179 97.3119 39.5509 97.291 39.5801C97.2701 39.6092 97.2437 39.634 97.2132 39.6529C97.1828 39.6719 97.1489 39.6846 97.1135 39.6905C97.0781 39.6963 97.0419 39.6951 97.007 39.687C94.9317 39.2498 92.7862 39.2689 90.7191 39.7429C88.6519 40.2168 86.7125 41.1344 85.035 42.432C84.9859 42.4748 84.922 42.4982 84.857 42.498Z",
    fill: "#3554A5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7292 59.152C62.6859 59.1521 62.6432 59.1419 62.6046 59.1223C62.566 59.1026 62.5326 59.0741 62.5072 59.039C60.6532 56.464 55.9402 54.523 51.5422 54.523C47.2362 54.523 44.5972 58.332 44.5702 58.371C44.5512 58.403 44.5258 58.4308 44.4957 58.4526C44.4655 58.4745 44.4312 58.4899 44.3949 58.498C44.3586 58.5061 44.3209 58.5067 44.2844 58.4998C44.2478 58.4928 44.213 58.4784 44.1822 58.4575C44.1514 58.4366 44.1252 58.4096 44.1052 58.3782C44.0852 58.3468 44.0719 58.3116 44.066 58.2749C44.06 58.2381 44.0617 58.2005 44.0709 58.1644C44.0801 58.1283 44.0965 58.0945 44.1192 58.065C44.2322 57.898 46.9412 53.977 51.5422 53.977C56.0992 53.977 61.0032 56.015 62.9502 58.719C62.9797 58.7597 62.9973 58.8078 63.0012 58.858C63.0051 58.9081 62.995 58.9583 62.9722 59.0031C62.9493 59.0479 62.9145 59.0855 62.8717 59.1118C62.8288 59.138 62.7795 59.152 62.7292 59.152Z",
    fill: "#3554A5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6109 68.246C57.5453 68.2465 57.4818 68.2233 57.4319 68.1808C57.382 68.1383 57.3491 68.0792 57.3391 68.0144C57.3292 67.9496 57.3429 67.8834 57.3777 67.8279C57.4126 67.7724 57.4662 67.7312 57.5289 67.712C59.3799 67.132 62.0419 62.312 62.0689 62.263C62.0861 62.2316 62.1093 62.2039 62.1372 62.1815C62.1651 62.1591 62.1972 62.1424 62.2315 62.1324C62.2659 62.1223 62.3019 62.1192 62.3375 62.1231C62.3731 62.1269 62.4075 62.1378 62.4389 62.155C62.4703 62.1722 62.498 62.1954 62.5204 62.2233C62.5428 62.2512 62.5595 62.2833 62.5695 62.3176C62.5796 62.352 62.5827 62.388 62.5788 62.4236C62.575 62.4591 62.5641 62.4936 62.5469 62.525C62.4339 62.732 59.7469 67.588 57.6929 68.234C57.6663 68.2421 57.6387 68.2462 57.6109 68.246Z",
    fill: "#3554A5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0713 33.05C66.6313 33.05 63.1533 29.804 63.1533 25.659C63.1533 25.5866 63.1821 25.5172 63.2333 25.466C63.2845 25.4148 63.3539 25.386 63.4263 25.386C63.4987 25.386 63.5682 25.4148 63.6194 25.466C63.6706 25.5172 63.6993 25.5866 63.6993 25.659C63.6993 29.498 66.9373 32.504 71.0713 32.504C72.9916 32.5275 74.8427 31.7885 76.2189 30.4491C77.5951 29.1097 78.3839 27.2792 78.4123 25.359C78.4123 25.2866 78.4411 25.2172 78.4923 25.166C78.5435 25.1148 78.6129 25.086 78.6853 25.086C78.7577 25.086 78.8272 25.1148 78.8784 25.166C78.9296 25.2172 78.9583 25.2866 78.9583 25.359C78.9296 27.4239 78.0832 29.3931 76.6047 30.8349C75.1262 32.2766 73.1363 33.0732 71.0713 33.05Z",
    fill: "#3554A5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9167 24.747C77.0697 24.542 76.1807 24.295 75.2637 24.119V16.984H67.3277L66.9967 23.693C66.4257 23.87 65.4387 24.341 64.2207 24.893C64.2207 24.922 64.2207 24.958 64.2207 24.986C64.2425 26.7901 64.9745 28.5129 66.2579 29.781C67.5414 31.0491 69.273 31.7602 71.0772 31.7602C72.8814 31.7602 74.613 31.0491 75.8965 29.781C77.1799 28.5129 77.9119 26.7901 77.9337 24.986C77.9337 24.886 77.9257 24.849 77.9217 24.751",
    fill: "#FBCDB4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1904 19.734C67.9724 21.499 70.2214 23.367 75.2624 23.399V17.415H67.3044L67.1904 19.734Z",
    fill: "#EEA584"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0166 9.225C75.6886 10.995 74.1806 11.389 73.2626 11.847C72.3446 12.305 72.9876 10.274 72.9876 10.274C71.2036 13.683 69.0006 15.192 66.5096 14.911C65.7493 14.7753 64.9657 14.9257 64.3096 15.333C64.4761 15.5795 64.7006 15.7813 64.9634 15.9208C65.2261 16.0602 65.5191 16.1331 65.8166 16.133C65.9575 16.132 66.0978 16.1143 66.2346 16.08C67.0056 19.356 69.3516 21.738 72.1276 21.738C75.5276 21.738 78.2906 18.157 78.2906 13.738C78.2883 13.3207 78.261 12.904 78.2086 12.49C77.6853 11.2731 76.9392 10.1647 76.0086 9.222",
    fill: "#FBCDB4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6586 41.857H50.0146V58.592H78.6586V41.857Z",
    fill: "#29314A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3682 33.72H51.4072V58.217H65.3682V33.72Z",
    fill: "#E5C77F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4903 33.138H53.5293V58.217H67.4903V33.138Z",
    fill: "#F8E3B1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8751 34.233H55.9141V58.218H69.8751V34.233Z",
    fill: "#D8D8DF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6094 33.72H57.6484V58.217H71.6094V33.72Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6235 37.996H58.6895V58.218H74.6235V37.996Z",
    fill: "#FABD5A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6373 37.405V45.577L59.4883 45.99V58.217H74.6223V37.405H60.6373Z",
    fill: "#F8E3B1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8263 40.441H64.9863V44.302H71.8263V40.441Z",
    fill: "#FFFAED"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8263 45.118H64.9863V45.989H71.8263V45.118Z",
    fill: "#FCECD3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8263 46.804H64.9863V47.675H71.8263V46.804Z",
    fill: "#FFFAED"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5452 35.238H59.4912V35.542H63.5452V35.238Z",
    fill: "#D8D8DF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 36.019H59.4912V36.323H68.4062V36.019Z",
    fill: "#D8D8DF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4062 36.712H59.4912V37.016H68.4062V36.712Z",
    fill: "#D8D8DF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2526 41.857H50.0156V58.592H66.2526V41.857Z",
    fill: "#F69063"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9209 58.592H78.6579V41.856H63.9209V58.592ZM74.2509 47.471H69.0509C68.7805 47.4626 68.524 47.3493 68.3357 47.1551C68.1475 46.9609 68.0422 46.701 68.0422 46.4305C68.0422 46.16 68.1475 45.9001 68.3357 45.7059C68.524 45.5117 68.7805 45.3984 69.0509 45.39H74.2509C74.3902 45.3857 74.5291 45.4094 74.6591 45.4597C74.7891 45.5101 74.9077 45.586 75.0078 45.6831C75.1079 45.7801 75.1874 45.8963 75.2418 46.0247C75.2961 46.1531 75.3242 46.2911 75.3242 46.4305C75.3242 46.5699 75.2961 46.7079 75.2418 46.8363C75.1874 46.9647 75.1079 47.0809 75.0078 47.1779C74.9077 47.275 74.7891 47.3509 74.6591 47.4013C74.5291 47.4516 74.3902 47.4753 74.2509 47.471Z",
    fill: "#FCA37C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4409 45.2177L76.8447 63.567L90.6681 65.5228L93.2642 47.1735L79.4409 45.2177Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3151 48.83L81.2725 49.131L85.2865 49.6991L85.3291 49.3981L81.3151 48.83Z",
    fill: "#D8D8DF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2055 49.604L81.1631 49.904L89.9901 51.1534L90.0326 50.8533L81.2055 49.604Z",
    fill: "#D8D8DF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1089 50.291L81.0664 50.591L89.8934 51.8404L89.9359 51.5403L81.1089 50.291Z",
    fill: "#D8D8DF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8169 52.359L80.7744 52.659L89.6014 53.9084L89.6439 53.6083L80.8169 52.359Z",
    fill: "#D8D8DF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7192 53.046L80.6768 53.346L89.5038 54.5954L89.5462 54.2953L80.7192 53.046Z",
    fill: "#D8D8DF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5738 54.068L80.5312 54.369L88.586 55.5088L88.6286 55.2078L80.5738 54.068Z",
    fill: "#D8D8DF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4302 55.091L80.3877 55.391L89.2147 56.6404L89.2572 56.3403L80.4302 55.091Z",
    fill: "#D8D8DF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3325 55.778L80.29 56.078L89.1171 57.3274L89.1595 57.0273L80.3325 55.778Z",
    fill: "#D8D8DF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1881 56.8L80.1455 57.101L88.2003 58.2408L88.2429 57.9398L80.1881 56.8Z",
    fill: "#D8D8DF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4672 42.248C86.6181 41.9853 85.7107 41.9773 84.8572 42.225C84.0832 42.55 83.6502 43.239 82.9762 43.675C82.4102 44.041 79.6992 44.009 80.7442 45.115C81.3069 45.544 81.9998 45.7671 82.7072 45.747C82.3282 46.678 81.4612 48.566 82.0622 49.547C82.4902 50.241 82.8702 49.722 83.4252 49.756C84.0152 49.792 84.2982 50.239 84.9312 50.166C85.2157 50.0836 85.517 50.0784 85.8042 50.151C86.1622 50.273 86.3702 50.523 86.7812 50.499C87.0662 50.481 87.2662 50.299 87.5742 50.337C87.9072 50.375 88.1872 50.62 88.5252 50.654C89.8812 50.791 91.0842 48.754 91.2992 47.619C91.4708 47.0331 91.5138 46.417 91.4253 45.8129C91.3368 45.2088 91.1187 44.631 90.7862 44.119C89.8823 43.1919 88.7303 42.545 87.4682 42.256",
    fill: "#FBCDB4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M82.706 46.018C82.6718 46.0179 82.6379 46.0115 82.606 45.999C82.5727 45.9859 82.5422 45.9663 82.5165 45.9414C82.4907 45.9165 82.4701 45.8867 82.4559 45.8538C82.4417 45.8209 82.4341 45.7855 82.4336 45.7497C82.4331 45.7139 82.4397 45.6783 82.453 45.645L83.071 44.081C83.0826 44.0456 83.1012 44.013 83.1259 43.9851C83.1505 43.9572 83.1806 43.9346 83.2143 43.9188C83.248 43.9029 83.2846 43.8941 83.3218 43.8929C83.359 43.8918 83.396 43.8982 83.4307 43.9119C83.4653 43.9255 83.4968 43.9461 83.5231 43.9724C83.5495 43.9987 83.5702 44.03 83.584 44.0646C83.5978 44.0992 83.6044 44.1362 83.6034 44.1734C83.6023 44.2106 83.5937 44.2472 83.578 44.281L82.962 45.842C82.9422 45.893 82.9075 45.9368 82.8623 45.9677C82.8172 45.9986 82.7637 46.0151 82.709 46.015",
    fill: "#EEA584"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M83.424 50.023C83.3693 50.0234 83.3159 50.007 83.271 49.976C83.2413 49.9559 83.2158 49.9302 83.1961 49.9002C83.1764 49.8702 83.1628 49.8367 83.1561 49.8015C83.1495 49.7663 83.1498 49.7301 83.1571 49.695C83.1645 49.6599 83.1787 49.6266 83.199 49.597L84.788 47.259C84.807 47.227 84.8323 47.1992 84.8625 47.1774C84.8926 47.1555 84.9269 47.1401 84.9633 47.132C84.9996 47.1239 85.0372 47.1233 85.0738 47.1302C85.1104 47.1372 85.1451 47.1516 85.176 47.1725C85.2068 47.1934 85.233 47.2204 85.253 47.2518C85.273 47.2832 85.2863 47.3184 85.2922 47.3551C85.2981 47.3919 85.2965 47.4295 85.2873 47.4656C85.2781 47.5017 85.2617 47.5355 85.239 47.565L83.65 49.903C83.625 49.94 83.5914 49.9703 83.552 49.9912C83.5125 50.0122 83.4686 50.0231 83.424 50.023Z",
    fill: "#EEA584"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5431 50.365C85.4937 50.3649 85.4453 50.3515 85.403 50.3261C85.3607 50.3007 85.3261 50.2643 85.3028 50.2209C85.2795 50.1774 85.2685 50.1284 85.2708 50.0791C85.2731 50.0298 85.2888 49.9821 85.3161 49.941L86.4341 48.266C86.4764 48.2121 86.5375 48.1761 86.6051 48.1652C86.6728 48.1542 86.7421 48.1691 86.7992 48.2069C86.8564 48.2447 86.8973 48.3026 86.9138 48.3691C86.9302 48.4356 86.921 48.5059 86.8881 48.566L85.7701 50.24C85.7452 50.2775 85.7115 50.3082 85.6719 50.3295C85.6323 50.3507 85.588 50.3619 85.5431 50.362",
    fill: "#EEA584"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5728 50.605C87.5223 50.6048 87.4728 50.5906 87.4298 50.564C87.3869 50.5373 87.3522 50.4993 87.3296 50.4541C87.307 50.4089 87.2974 50.3583 87.3018 50.308C87.3063 50.2577 87.3246 50.2095 87.3548 50.169L88.4388 48.723C88.4829 48.6672 88.5471 48.6309 88.6176 48.6217C88.6882 48.6125 88.7595 48.6312 88.8164 48.6738C88.8734 48.7164 88.9114 48.7796 88.9225 48.8499C88.9336 48.9201 88.9168 48.9919 88.8758 49.05L87.7908 50.496C87.7655 50.53 87.7326 50.5576 87.6948 50.5767C87.6569 50.5958 87.6152 50.6048 87.5728 50.605Z",
    fill: "#EEA584"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1332 58.593C58.7085 57.4309 59.6421 56.4843 60.7961 55.893C62.6171 55.047 62.0662 52.771 63.5442 52.836C65.0222 52.901 62.7442 56.386 63.9442 56.92C65.1442 57.454 69.5072 54.775 70.6122 55.626C71.7172 56.477 68.4022 58.218 68.4022 58.218L73.2792 58.593C72.1011 59.3708 70.7721 59.8912 69.3792 60.12C66.9686 60.7032 64.6045 61.4639 62.3062 62.396C62.3062 62.396 59.6472 62.89 58.1312 61.55C56.9572 60.513 58.1312 58.593 58.1312 58.593",
    fill: "#FBCDB4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6291 59.813C64.5662 59.8129 64.5053 59.7911 64.4566 59.7514C64.408 59.7116 64.3745 59.6562 64.362 59.5946C64.3494 59.533 64.3585 59.469 64.3876 59.4133C64.4168 59.3576 64.4643 59.3137 64.5221 59.289C65.6401 58.812 68.2141 57.989 68.3221 57.958C68.3901 57.9394 68.4626 57.9479 68.5245 57.9816C68.5864 58.0153 68.6329 58.0716 68.6542 58.1388C68.6756 58.206 68.6701 58.2788 68.6389 58.342C68.6077 58.4052 68.5533 58.454 68.4871 58.478C68.4601 58.486 65.8281 59.325 64.7331 59.79C64.6994 59.8049 64.6629 59.8124 64.6261 59.812",
    fill: "#EEA584"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M109.81 72.068H102.006V75.103H109.81V72.068Z",
    fill: "#0045B2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M106.894 101.668H71.5281L70.7471 64.742H107.674L106.894 101.668Z",
    fill: "#1F76FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M70.885 71.245L107.507 72.635L107.673 64.741H70.748L70.885 71.245Z",
    fill: "#0045B2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M70.748 64.742L71.529 101.668H80.8941L80.114 64.742H70.748Z",
    fill: "#0045B2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M109.81 64.742H69.6611V69.338H109.81V64.742Z",
    fill: "#1F76FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5421 64.742H69.6621V69.338H81.5421V64.742Z",
    fill: "#0045B2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6009 72.068H67.7969V75.103H75.6009V72.068Z",
    fill: "#1F76FF"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M107.899 26.538C108.883 23.8011 110.726 21.4136 113.195 19.6739C115.664 17.9343 118.651 16.9197 121.781 16.757C124.912 16.5944 128.047 17.2909 130.795 18.7595C133.544 20.2281 135.783 22.4035 137.233 25.0139C138.683 27.6242 139.279 30.5535 138.948 33.4354C138.616 36.3173 137.371 39.0239 135.368 41.2168C133.365 43.4096 130.694 44.9914 127.688 45.7643C124.681 46.5372 121.474 46.4669 118.466 45.5621L114.689 48.5071L114.71 43.9255C111.642 42.1135 109.301 39.4105 108.064 36.2546C106.828 33.0987 106.769 29.6748 107.899 26.538ZM130.926 34.1141C131.311 34.1734 131.704 34.1261 132.054 33.9782C132.405 33.8302 132.698 33.5882 132.896 33.2828C133.094 32.9774 133.188 32.6223 133.166 32.2624C133.145 31.9026 133.009 31.5541 132.775 31.261C132.541 30.9679 132.221 30.7434 131.853 30.6159C131.486 30.4885 131.089 30.4637 130.712 30.5448C130.336 30.6259 129.996 30.8092 129.737 31.0715C129.477 31.3338 129.309 31.6634 129.255 32.0185C129.181 32.4947 129.316 32.9831 129.629 33.3761C129.943 33.7691 130.409 34.0345 130.926 34.1141ZM123.078 32.9053C123.464 32.9647 123.856 32.9174 124.207 32.7694C124.558 32.6214 124.85 32.3794 125.048 32.074C125.246 31.7686 125.341 31.4135 125.319 31.0537C125.298 30.6938 125.161 30.3453 124.928 30.0522C124.694 29.7591 124.373 29.5346 124.006 29.4071C123.639 29.2797 123.242 29.2549 122.865 29.336C122.488 29.4171 122.149 29.6004 121.889 29.8627C121.63 30.125 121.462 30.4546 121.407 30.8097C121.334 31.2859 121.469 31.7743 121.782 32.1673C122.096 32.5603 122.562 32.8258 123.078 32.9053ZM115.328 31.7114C115.713 31.7707 116.106 31.7234 116.456 31.5755C116.807 31.4275 117.1 31.1855 117.298 30.8801C117.496 30.5747 117.59 30.2196 117.568 29.8597C117.547 29.4999 117.411 29.1513 117.177 28.8583C116.943 28.5652 116.623 28.3407 116.255 28.2132C115.888 28.0858 115.491 28.061 115.114 28.1421C114.738 28.2232 114.398 28.4065 114.138 28.6688C113.879 28.9311 113.711 29.2607 113.657 29.6158C113.583 30.092 113.718 30.5804 114.031 30.9734C114.345 31.3664 114.811 31.6318 115.328 31.7114Z",
    fill: "#F58F63"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9196 28.6658C36.1851 26.5793 34.8228 24.755 33.0029 23.4209C31.183 22.0869 28.9864 21.3023 26.6878 21.1653C24.3891 21.0283 22.0905 21.545 20.0793 22.6507C18.0682 23.7565 16.4338 25.4022 15.3804 27.3821C14.3271 29.362 13.9016 31.5882 14.1573 33.7823C14.4129 35.9764 15.3383 38.041 16.8177 39.7179C18.2971 41.3948 20.2648 42.6096 22.4748 43.2103C24.6848 43.8111 27.039 43.7711 29.243 43.0955L32.0283 45.3521L31.9929 41.8661C34.2372 40.5005 35.9449 38.4538 36.8391 36.0579C37.7333 33.662 37.7617 31.0572 36.9196 28.6658ZM20.0487 34.3327C19.7662 34.3762 19.4777 34.3385 19.2196 34.2245C18.9616 34.1104 18.7456 33.9251 18.599 33.6919C18.4524 33.4587 18.3818 33.1881 18.3961 32.9144C18.4103 32.6406 18.5088 32.3761 18.6791 32.1541C18.8494 31.9321 19.0839 31.7626 19.3528 31.6672C19.6218 31.5717 19.9131 31.5546 20.1901 31.6179C20.467 31.6812 20.7171 31.8221 20.9087 32.0227C21.1003 32.2234 21.2247 32.4749 21.2664 32.7453C21.3223 33.1079 21.2254 33.4789 20.997 33.7766C20.7686 34.0743 20.4275 34.2743 20.0487 34.3327ZM25.8038 33.4461C25.5213 33.4897 25.2328 33.452 24.9748 33.3379C24.7168 33.2239 24.5008 33.0385 24.3542 32.8053C24.2076 32.5721 24.1369 32.3016 24.1512 32.0278C24.1655 31.7541 24.264 31.4895 24.4343 31.2675C24.6046 31.0455 24.839 30.8761 25.108 30.7807C25.3769 30.6852 25.6683 30.6681 25.9452 30.7314C26.2222 30.7947 26.4722 30.9355 26.6638 31.1362C26.8554 31.3369 26.9799 31.5883 27.0215 31.8588C27.0774 32.2214 26.9805 32.5924 26.7521 32.8901C26.5238 33.1878 26.1827 33.3878 25.8038 33.4461ZM31.4882 32.5705C31.2057 32.614 30.9172 32.5764 30.6591 32.4623C30.4011 32.3483 30.1851 32.1629 30.0386 31.9297C29.892 31.6965 29.8213 31.426 29.8355 31.1522C29.8498 30.8785 29.9483 30.6139 30.1186 30.3919C30.2889 30.1699 30.5234 30.0005 30.7923 29.905C31.0613 29.8096 31.3526 29.7925 31.6296 29.8558C31.9065 29.919 32.1566 30.0599 32.3482 30.2606C32.5398 30.4613 32.6643 30.7127 32.7059 30.9832C32.7618 31.3458 32.6649 31.7168 32.4365 32.0145C32.2082 32.3122 31.867 32.5122 31.4882 32.5705Z",
    fill: "#F58F63"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2444_3193",
    transform: "scale(0.0196078 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2444_3193",
    transform: "scale(0.0208333 0.5)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_2444_3193",
    transform: "scale(0.0227273 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_2444_3193",
    transform: "scale(0.0238095 0.5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2444_3193",
    x1: 119.899,
    y1: 23.0027,
    x2: 119.899,
    y2: 53.0027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7986A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2444_3193",
    x1: 30.9997,
    y1: 27.5,
    x2: 30.9997,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8ECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7986A5"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2444_3193",
    width: 51,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAICAYAAABUHMdEAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAM6ADAAQAAAABAAAACAAAAAA6NOb1AAAAXElEQVQ4EWP8//8/Awh4eoazACkgZmRmZITRjCAxIB8fzcgCVM8M1IdEMwL5MDPQaRSzgHogaiE0shmoZiLcAXcfkn0QtUxARcMGjHpmsEblaMyMxgwdQmBYJTMA36kE6yIGn7gAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2444_3193",
    width: 48,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAACCAYAAAAesF8hAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAMKADAAQAAAABAAAAAgAAAAAjHqXQAAAAO0lEQVQYGWP8//8/g4dHGBMjIyMLAwMDM4RmZGFkZADyGaF8BiAflzxYHZo8TD1IPz55yu1jAjp6SAMA6skE3+mvRBUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_2444_3193",
    width: 44,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAICAYAAACCuR0hAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAALKADAAQAAAABAAAACAAAAADr50xdAAAAVUlEQVQ4EWOMjy/a+P///z8MDP///P/PAKVBfAYgHyQGZv/GpwamF6oWpOc3RAxhDpp5UHPhdkLNR7ETXQ2YzwQ0aEiBUQfTOrpGQ3g0hNFCYMglCQDK3nj1/0foPgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_2444_3193",
    width: 42,
    height: 2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAACCAYAAAAuPE4AAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAKqADAAQAAAABAAAAAgAAAAAGY+P0AAAATklEQVQYGdWN0Q0AIQhD6y3qDo7mepJUCmeCI8gPpZRH631MkgZwkVA3ny+dHsI/OvO6Sz8ZNSMO1s9TzpnxR35hBaPuiqbfR9Y+F0/UBnIdduhmS0sHAAAAAElFTkSuQmCC"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteAccountOtp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_account_otp.1aa7cb53.svg";
export { ForwardRef as ReactComponent };